<template>
  <div class="home">
    <v-carousel hide-delimiters cycle>
      <v-carousel-item v-for="(item, i) in items" :key="i" :src="item.src">
        <v-row class="fill-height" align="center" justify="center">
          <div class="text-h1 white--text">
            {{ item.title }}
          </div>
        </v-row></v-carousel-item
      >
    </v-carousel>
    <div class="container">
      <backtonachspeise></backtonachspeise>
    </div>
    <v-card>
      <v-card-title class="display-3">
        Eis mit Früchte
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="desserts"
        :search="search"
        :items-per-page="-1"
      >
        <template v-slot:item.speise="{ item }">
          <b>{{ item.speise }}</b>
        </template>
        <template v-slot:item.preis="{ item }">
          <b>{{ item.preis }}</b>
        </template></v-data-table
      >
    </v-card>
  </div>
</template>

<script>
import Backtonachspeise from './Backtonachspeise.vue';
export default {
  components: { Backtonachspeise },
  name: 'Eisfruechte',
  data() {
    return {
      items: [
        {
          src: require('../assets/images/eiskaffeemithintergrund.jpg'),
          title: '',
        },
      ],
      search: '',
      headers: [
        {
          text: 'Nummer',
          align: 'start',
          sortable: false,
          value: 'nummer',
        },
        { text: 'Speise', value: 'speise' },
        { text: 'Allergene', value: 'allergene' },
        { text: 'Preis', value: 'preis' },
      ],
      desserts: [
        {
          nummer: 'E1',
          speise: 'gemischtes Eis mit Obst',
          allergene: '(A, H, G)',
          preis: '5,00 €',
        },
        {
          nummer: 'E2',
          speise: 'Bananensplit',
          allergene: '(A, H, G)',
          preis: '4,50 €',
        },
        {
          nummer: 'E3',
          speise: 'Eiskaffee',
          allergene: '(A, H, G)',
          preis: '4,30 €',
        },
        {
          nummer: 'E4',
          speise: 'Gemischtes Eis mit Schlagobers und Schoko Sauce',
          allergene: '(A, E, H, G)',
          preis: '4,50 €',
        },
      ],
    };
  },
  methods: {
    top() {
      window.scrollTo(0, 0);
    },
  },
  created() {
    this.top();
  },
};
</script>

<style lang="scss" scoped></style>
